import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

// El paper del Menu y los MenuItem heredan el estilo global mode-aware definido en
// `common/theme/components.js` (MuiMenu / MuiMenuItem: superficie, hairline, sombra
// teñida, selección dorada). Por eso aquí NO se hardcodean colores: el componente se ve
// correcto y premium tanto en oscuro como en claro. El color del texto del botón se pasa
// por prop porque depende del contenedor (AppBar adaptativo vs. overlay oscuro del login).
function LanguageSelector({ selectedLanguage, onSelect, color = undefined }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    const { language } = event.target.dataset;
    setAnchorEl(null);
    if (language) {
      onSelect(language);
    }
  };

  return (
    <div>
      <Button
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        color="inherit"
        size="small"
        onClick={handleClick}
        startIcon={<LanguageIcon sx={{ fontSize: '1.1rem' }} />}
        sx={{
          minWidth: 'auto',
          px: 1.5,
          py: 0.5,
          textTransform: 'uppercase',
          fontSize: '0.875rem',
          fontWeight: 600,
          color: color || 'inherit',
          borderRadius: 2,
          transition: 'color 200ms cubic-bezier(0.32, 0.72, 0, 1)',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}>
        {selectedLanguage}
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
          sx: { py: 0.5 }
        }}
        PaperProps={{ sx: { minWidth: 100, maxWidth: 120, mt: 1 } }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <MenuItem
          onClick={handleClose}
          data-language="es"
          selected={selectedLanguage === 'es'}
          sx={{ fontSize: '0.875rem', fontWeight: 600, textTransform: 'uppercase' }}>
          🇪🇸 ES
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          data-language="en"
          selected={selectedLanguage === 'en'}
          sx={{ fontSize: '0.875rem', fontWeight: 600, textTransform: 'uppercase' }}>
          🇺🇸 EN
        </MenuItem>
      </Menu>
    </div>
  );
}

LanguageSelector.propTypes = {
  selectedLanguage: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  color: PropTypes.string
};

export default LanguageSelector;
